import { AbstractStudentStore } from '@coach-bot/data-access/shared/stores/abstract/abstract-student.store';
import { LocalStorageService } from '../services';

export class StudentStore extends AbstractStudentStore {
  constructor(protected localStorageService: LocalStorageService) {
    super(localStorageService);
  }
}
